import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FAQSection = () => {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(0);

  const faqs = [
    {
      question: "How do I register and create a matrimony profile?",
      answer: "Registration is free and takes just a few minutes. Simply click 'Register', enter your personal and family details, set your partner preferences, and upload your profile photo to get started."
    },
    {
      question: "Can parents manage the account along with the candidate?",
      answer: "Yes, our Elder-Supervised Dashboard allows dual logins so parents and candidates can shortlist profiles together effortlessly."
    },
    {
      question: "What is Gothram verification & Horoscope Porutham?",
      answer: "Every profile includes verified Gothram details and automated Porutham match reports to ensure traditional compatibility."
    },
    {
      question: "Are all profiles 100% ID verified?",
      answer: "Yes! Every single profile undergoes mandatory Government ID verification (Aadhaar/PAN/Voter ID) before activation."
    }
  ];

  const toggleFAQ = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section className="relative w-full py-16 sm:py-20 md:py-24 lg:py-28 overflow-hidden bg-white">
      {/* Background Text */}
      <div className="absolute top-0 left-0 right-0 pointer-events-none">
        <h2
          className="text-[150px] sm:text-[300px] md:text-[500px] lg:text-[952px] font-['BD_Megalona_DEMO_Personal_Use_Only'] italic lowercase text-[#ffefef]/60 leading-none home-bg-text-lineheight"
        >
          frequent
        </h2>
      </div>

      <div className="relative w-full max-w-[1360px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-wide bg-gradient-to-r from-[#8a216b] to-[#f03f16] bg-clip-text text-transparent mb-3 sm:mb-4">
            frequently asked
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[48px] font-semibold text-text-primary capitalize mb-4 sm:mb-5 md:mb-6">
            Got Questions? We Have Answers.
          </h2>
          <p className="text-base sm:text-lg text-text-primary/60 max-w-2xl mx-auto">
            Everything you need to know about our Anuppagoundar matrimonial platform.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4 sm:space-y-5 md:space-y-6 max-w-4xl mx-auto">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              className={`rounded-3xl overflow-hidden transition-all ${expandedIndex === index
                  ? 'bg-gradient-to-b from-[#fff1f3] to-white border border-[#f03f16]/40 shadow-md'
                  : 'bg-white/90 border border-gray-200 hover:border-gray-300'
                }`}
            >
              <button
                type="button"
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 p-6 sm:p-7 md:p-8 text-left cursor-pointer"
              >
                <h3
                  className={`text-md sm:text-lg md:text-[18px] font-semibold ${expandedIndex === index
                      ? 'bg-gradient-to-r from-[#8a216b] to-[#f03f16] bg-clip-text text-transparent'
                      : 'text-text-primary'
                    }`}
                >
                  {faq?.question}
                </h3>
                <div
                  className={`p-2 rounded-full transition-transform duration-300 flex-shrink-0 ${expandedIndex === index ? 'rotate-180 bg-[#fff0f3] text-[#f03f16]' : 'bg-gray-100 text-gray-600'
                    }`}
                >
                  <svg className="w-5 h-5 stroke-current fill-none" viewBox="0 0 24 24">
                    <path d="M19 9l-7 7-7-7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </button>
              {expandedIndex === index && faq?.answer && (
                <div className="px-6 sm:px-7 md:px-8 pb-6 sm:pb-7 md:pb-8 border-t border-red-50/50 pt-4">
                  <p className="text-base sm:text-lg text-text-primary/75 leading-relaxed">{faq?.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div
          className="mt-12 sm:mt-16 md:mt-20 bg-cover bg-center rounded-3xl p-8 sm:p-10 md:p-12 text-center"
          style={{
            backgroundImage: "url('/images/couple_pose_1.webp')"
          }}
        >
          <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-[36px] font-semibold text-white capitalize mb-3 sm:mb-4">
            Verified Profiles. Genuine Matches.
          </h3>
          <p className="text-base sm:text-lg text-white/70 max-w-2xl mx-auto">
            A secure matrimonial platform built exclusively for
            <br className="hidden sm:block" />
            the Appuppa Gounder community.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;